import { KitType } from '@repo/types';
import { TextColor, Typography } from '@repo/ui';
import { AgeGroup, getAgeGroup } from '@repo/utils';
import background from 'assets/images/summary/first-look/dont_worry.svg';
import c from 'classnames';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import React from 'react';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';
import styles from './DontWorry.module.css';
import slideStyles from './Slides.module.css';

export const DontWorry: React.FC = () => {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const isVaginal = currentKit?.sampling_type === KitType.VAGINAL;
  const isAdult =
    getAgeGroup(currentKit?.age_at_sampling ?? 0) === AgeGroup.ADULT;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.dontWorry }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color={TextColor.GREEN}
          weight='medium'
        >
          What to do next
        </Typography>
        <Typography variant='heading-l'>
          Improve {isAdult ? 'your' : `${currentTinyAccount?.first_name}'s`}{' '}
          {isVaginal ? 'vaginal' : 'gut'} microbiome by following your
          personalized recommendations on diet, lifestyle changes and
          supplementations!
        </Typography>
      </div>
      <img src={background} className={styles.backgroundImg} />
    </div>
  );
};
